import axios from 'axios'
import { useAuthStore } from '@/stores/authStore.js'
import { useErrorsStore } from '@/stores/errorsStore.js'
import { useAuth } from '@/composables/useAuth'

const { signOut } = useAuth()

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

axiosInstance.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    const authStore = useAuthStore()
    const errorsStore = useErrorsStore()

    if (error.response?.status === 401) {
      const authData = authStore.authData

      if (error.response.config.url.includes('/login_check')) {
        return Promise.reject(error)
      }
      /************************************************************************
			// CHECK IF IT IS A 401 ERROR RELATED TO THE '/token/refresh' ENDPOINT
			*************************************************************************/
      if (error.response.config.url.includes('/token/refresh')) {
        const queryString = location.href.split('?')[1]
        const formattedQuery = queryString
          ? Object.fromEntries(new URLSearchParams(queryString))
          : {}

        const redirectPayload = {
          redirectPath: location.pathname,
          ...formattedQuery
        }

        await signOut(redirectPayload)
        return Promise.reject(error)
      }

      /********************************************************************************************
			// IF THE access_token IS NOT VALID, CALL '/token/refresh' TO REQUEST A NEW ONE
			// AND RETRY SENDING THE REQUEST AGAIN
			*********************************************************************************************/
      if (authData.token) {
        const res = await authStore.refreshToken(authData.refresh_token)
        error.config.headers['Authorization'] = `Bearer ${res.token}`
        return axios(error.config)
      }
    } else if (error.response.status === 422 || error.response.status === 500) {
      errorsStore.setError({
        title: error.response.data['hydra:title'],
        description: error.response.data['hydra:description'],
        url: error.response.config.url
      })
      return Promise.reject(error)
    } else {
      return Promise.reject(error)
    }
  }
)

export default axiosInstance
